module.exports = __webpack_public_path__ + "static/favicon-5b7c46e42cb63f55aa2916e36423dedd.ico";